import { gql } from "@apollo/client";

const GET_FUND_OVERLAP = gql`
  query GetFundOverlap(
    $fundId1: Int!
    $fundId2: Int!
    $holdingMonth: String!
    $holdingYear: String!
  ) {
    getFundOverlap(
      fundId1: $fundId1
      fundId2: $fundId2
      holdingMonth: $holdingMonth
      holdingYear: $holdingYear
    ) {
      stockName
      ptHoldingInFund1
      ptHoldingInFund2
    }
  }
`;

export default GET_FUND_OVERLAP;